import { css } from 'styled-components';

// CONSTANTS
// import breakpoints from '@/utility/breakpoints';

const commonPartnerStyles = css``;

export default commonPartnerStyles;
